/* eslint-disable @typescript-eslint/no-explicit-any */
import { AptunoErrorType } from '../Core';

export type AptunoError = {
  type: AptunoErrorType;
  code: string;
  params?: any;
  description?: string;
};

export class ResourceNotFoundError implements AptunoError {
  public readonly type = AptunoErrorType.APPLICATION;
  public readonly code = 'RESOURCE_NOT_FOUND';
  public readonly description: string;

  constructor(public readonly resourceType: string, public readonly params?: any) {
    this.description = `The resource [${resourceType}] could not be found`;
  }
}

export const GeneralAptunoErrorType = {
  isResourceNotFound: (error: AptunoError): error is ResourceNotFoundError => error.code === 'RESOURCE_NOT_FOUND',

  isResourceAlreadyExists: (error: AptunoError): boolean => error.code === 'RESOURCE_ALREADY_EXISTS',
};
